import"./index-8p04sssx.mjs";
import {
  createRectTransformImplementations
} from "./index-s9mrx750.mjs";
import {
  assertEffectParamsObject,
  assertRequiredFiniteNumber
} from "./index-4fvp93ps.mjs";

// src/scale/index.ts
import { Internals } from "remotion";
var { createEffect } = Internals;
var scaleSchema = {
  scale: {
    type: "number",
    min: 0.1,
    max: 10,
    step: 0.1,
    default: 1,
    description: "Factor",
    hiddenFromList: false,
    defaultKeyframeOutput: "perceptual-scale"
  },
  horizontal: {
    type: "boolean",
    default: true,
    description: "Horizontal"
  },
  vertical: {
    type: "boolean",
    default: true,
    description: "Vertical"
  }
};
var resolve = (p) => ({
  scale: p.scale,
  horizontal: p.horizontal ?? true,
  vertical: p.vertical ?? true
});
var validateScaleParams = (params) => {
  assertEffectParamsObject(params, "Scale");
  assertRequiredFiniteNumber(params.scale, "scale");
  if (typeof params.horizontal !== "undefined" && typeof params.horizontal !== "boolean") {
    throw new TypeError(`"horizontal" must be a boolean, but got ${JSON.stringify(params.horizontal)}`);
  }
  if (typeof params.vertical !== "undefined" && typeof params.vertical !== "boolean") {
    throw new TypeError(`"vertical" must be a boolean, but got ${JSON.stringify(params.vertical)}`);
  }
  const resolved = resolve(params);
  if (resolved.scale <= 0) {
    throw new TypeError(`"scale" must be greater than 0, but got ${JSON.stringify(resolved.scale)}`);
  }
};
var scale = createEffect({
  type: "dev.remotion.effects.scale",
  label: "scale()",
  documentationLink: "https://www.remotion.dev/docs/effects/scale",
  calculateKey: (params) => {
    const r = resolve(params);
    return `scale-${r.scale}-${r.horizontal}-${r.vertical}`;
  },
  implementations: {
    ...createRectTransformImplementations("scale", (params, width, height) => {
      const r = resolve(params);
      const scaledWidth = width * (r.horizontal ? r.scale : 1);
      const scaledHeight = height * (r.vertical ? r.scale : 1);
      return {
        x: (width - scaledWidth) / 2,
        y: (height - scaledHeight) / 2,
        width: scaledWidth,
        height: scaledHeight
      };
    }),
    "2d": Internals.createEffectImplementation({
      setup: () => null,
      apply: ({ source, target, width, height, params }) => {
        const ctx = target.getContext("2d");
        if (!ctx) {
          throw new Error("Failed to acquire 2D context for scale effect. The canvas may have been assigned a different context type.");
        }
        const r = resolve(params);
        const scaleX = r.horizontal ? r.scale : 1;
        const scaleY = r.vertical ? r.scale : 1;
        if (scaleX === 1 && scaleY === 1) {
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(source, 0, 0, width, height);
          return;
        }
        ctx.clearRect(0, 0, width, height);
        ctx.save();
        const centerX = width / 2;
        const centerY = height / 2;
        ctx.translate(centerX, centerY);
        ctx.scale(scaleX, scaleY);
        ctx.translate(-centerX, -centerY);
        ctx.drawImage(source, 0, 0, width, height);
        ctx.restore();
      },
      cleanup: () => {
        return;
      }
    })
  },
  schema: scaleSchema,
  validateParams: validateScaleParams
});
export {
  scale
};
